import React, { useEffect, useState } from "react"
import axios from "axios"
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  heigth: 800,
  bgcolor: '#87770a',
  border: '0px solid #ffffff',
  boxShadow: 24,
  p: 4,
};

function Academy(){

  const ACADEMY_API_URL = `https://nsmatrixbasketball.com/nsmatrix/api/academy`
  const [overviewText, setOverviewText] = useState('')
  const [flag, setFlag] = useState(false)
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    getInfo()
}, [flag]);

  function getInfo() {
    axios.get(`${ACADEMY_API_URL}/read.php`).then((res) => {
        setOverviewText(res.data[0]['overview_text'])
        setFlag(true)
    }, (error) => {
    })
}

    return(
      <div>
  <Modal
  open={open}
  onClose={handleClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box sx={style}>
    <a target="#" href="https://forms.gle/2vYDEhY7bwwZ6mvT6" >
      <img src={require('../assets/images/V3.png')} heigth={'100%'} width={'100%'} alt="" />
    </a>
    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
    </Typography>
  </Box>
</Modal>
        <div className="sportsmagazine-main-section sportsmagazine-bloglarge-full">
        <div className="container">
          <div className="row">
            <div className>
              <div className="sportsmagazine-blog sportsmagazine-bloglarge">
                <ul className="row">
                  <li className="col-md-12">
                    <figure><img src={require('../assets/images/NS_Matrix_website_logo-preview.png')} alt="" /></figure>
                    <div className="sportsmagazine-bloglarge-text">
                      <p>
                       <pre>{overviewText}</pre>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="sportsmagazine-gallery grid sportsmagazine-modern-gallery">
                <ul className="row">
                  <li className="col-md-4 grid-item">    
                    <figure>
                      <a data-fancybox-group="group" href={require('../assets/extra-images/academy1.jpg')} className="fancybox"><img src={require('../assets/extra-images/academy1.jpg')} alt="" /></a>
                      <span />
                    </figure>
                  </li>
                  <li className="col-md-4 grid-item">    
                    <figure>
                      <a data-fancybox-group="group" href={require('../assets/extra-images/academy2.jpg')} className="fancybox"><img src={require('../assets/extra-images/academy2.jpg')} alt="" /></a>
                      <span />
                    </figure>
                  </li>
                  <li className="col-md-4 grid-item">    
                    <figure>
                      <a data-fancybox-group="group" href={require('../assets/extra-images/academy3.jpg')} className="fancybox"><img src={require('../assets/extra-images/academy3.jpg')} alt="" /></a>
                      <span />
                    </figure>
                  </li>
                  <li className="col-md-4 grid-item">    
                    <figure>
                      <a data-fancybox-group="group" href={require('../assets/extra-images/academy4.jpg')} className="fancybox"><img src={require('../assets/extra-images/academy4.jpg')} alt="" /></a>
                      <span />
                    </figure>
                  </li>
                  <li className="col-md-4 grid-item">    
                    <figure>
                      <a data-fancybox-group="group" href={require('../assets/extra-images/academy5.jpg')} className="fancybox"><img src={require('../assets/extra-images/academy5.jpg')} alt="" /></a>
                      <span />
                    </figure>
                  </li>
                  <li className="col-md-4 grid-item">    
                    <figure>
                      <a data-fancybox-group="group" href={require('../assets/extra-images/academy6.jpg')} className="fancybox"><img src={require('../assets/extra-images/academy6.jpg')} alt="" /></a>
                      <span />
                    </figure>
                  </li>
                  <li className="col-md-4 grid-item">    
                    <figure>
                      <a data-fancybox-group="group" href={require('../assets/extra-images/academy7.jpg')} className="fancybox"><img src={require('../assets/extra-images/academy7.jpg')} alt="" /></a>
                      <span />
                    </figure>
                  </li>
                  <li className="col-md-4 grid-item">    
                    <figure>
                      <a data-fancybox-group="group" href={require('../assets/extra-images/academy8.jpg')} className="fancybox"><img src={require('../assets/extra-images/academy8.jpg')} alt="" /></a>
                      <span />
                    </figure>
                  </li>
                  <li className="col-md-4 grid-item">    
                    <figure>
                      <a data-fancybox-group="group" href={require('../assets/extra-images/academy9.jpg')} className="fancybox"><img src={require('../assets/extra-images/academy9.jpg')} alt="" /></a>
                      <span />
                    </figure>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    );
}

export default Academy;